import * as React from 'react';
const SvgMeta = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="#3488ff"
      d="M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
    />
    <path
      fill="#fff"
      d="M19.43 8.212C18.472 6.77 17.213 6 15.894 6c-.79 0-1.57.35-2.289.99-.49.431-.94.972-1.36 1.542-.519-.66-.999-1.17-1.468-1.551C9.886 6.25 9.036 6 8.187 6c-.55 0-1.08.14-1.569.38-.49.24-.94.59-1.34 1.021-.27.28-.519.6-.739.951C3.53 9.903 3 11.915 3 13.847c0 .53.05 1.03.16 1.48.05.231.12.441.2.651s.17.4.28.57C4.16 17.42 4.999 18 6.328 18c1.12 0 1.97-.51 2.968-1.841.57-.761.86-1.222 2-3.253l.57-1.011c.049-.09.089-.16.139-.24l.14.22 1.609 2.712c.54.91 1.25 1.922 1.849 2.492.78.74 1.49.921 2.299.921.64 0 1.16-.17 1.559-.43.4-.26.69-.6.89-.941.41-.71.649-1.602.649-2.823 0-2.051-.51-4.033-1.56-5.614zm-9.114 3.213c-.57.88-1.41 2.271-2.129 3.272-.89 1.241-1.36 1.371-1.859 1.371-.39 0-.78-.18-1.04-.6-.2-.32-.35-.85-.35-1.541 0-1.672.47-3.413 1.24-4.584.1-.16.22-.29.33-.43l.1-.13c.01-.01.03-.02.04-.04.29-.311.6-.551.94-.671.18-.06.36-.1.55-.1.949 0 1.538.6 2.008 1.09.23.25.55.661.92 1.192l-.76 1.18zm7.576 4.633c-.44 0-.77-.17-1.25-.76-.37-.45-1.009-1.411-2.118-3.283l-.46-.77c-.33-.551-.64-1.041-.94-1.492.05-.08.1-.17.16-.25.84-1.251 1.59-1.962 2.519-1.962.86 0 1.639.57 2.239 1.502.85 1.32 1.239 3.162 1.239 4.824 0 1.16-.28 2.181-1.38 2.181z"
    />
  </svg>
);
export default SvgMeta;
